<template>
  <ul class="memberInfo">
    <li>
      <img :src="orderDeatilsData.headImgUrl ? (orderDeatilsData.headImgUrl+'?x-oss-process=image/resize,m_lfit,w_120,h_120') : 'static/images/head.png'" class="img" />
    </li>
    <li>
      <el-tooltip class="item" effect="light" :content="orderDeatilsData.dtoList ? orderDeatilsData.dtoList.customerName ? orderDeatilsData.dtoList.customerName :'新增顾客' :orderDeatilsData.memberName ?orderDeatilsData.memberName : '新增顾客'" placement="top-start">
        <p class="name">
          <img v-if="orderDeatilsData.memberType == 1" src="@/assets/images/crown.png" />
          <img v-else-if="orderDeatilsData.memberType == 2" src="@/assets/images/plante.png" />
          姓名：{{ orderDeatilsData.dtoList ? orderDeatilsData.dtoList.customerName ? orderDeatilsData.dtoList.customerName :'新增顾客' :orderDeatilsData.memberName ?orderDeatilsData.memberName : '新增顾客' }}
        </p>
      </el-tooltip>
      <p>
        {{ Lib.starPhone(orderDeatilsData.phone) ||'--' }}
        <span v-if="orderDeatilsData.phone" class="gender" :class="orderDeatilsData.sex=='女'?'gender_g':orderDeatilsData.sex=='男'?'gender_b' :'gender_w' ">{{ orderDeatilsData.sex=='女'?'女':orderDeatilsData.sex=='男'?'男' :'?' }}</span>
        <span v-if="orderDeatilsData.distributorInfo" class="super">分销员</span>
      </p>
    </li>
    <li v-if="orderDeatilsData.cardNo">
      <p>会员等级：{{ orderDeatilsData.grade||'--' }}</p>
      <p>会员卡号：{{ orderDeatilsData.cardNo||'--' }}</p>
    </li>
  </ul>
</template>

<script>

export default {
  props: {
    orderDeatilsData: {
      type: Object,
      default: () => { }
    },
  },
  data() {
    return { };
  },
  activated() {},
  methods: {}
};
</script>
<style lang="less" scoped>
  .memberInfo{
    list-style:none;
    padding:10px 30px;
    list-style:none;
    display: flex;
    li{
      margin: 0%;
      .img{
        width: 60px;
        height: 60px;
        border-radius: 50%;

      }
      p{
        font-size: 14px;
        color: #2D2F33;
        line-height: 30px;
        img {
          width: 20px;
          height: 20px;
          margin:0 5px 0 0;
          vertical-align: middle;
        }
      }
      .name{
        width: 300px;
        cursor: pointer;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    li:nth-child(2){
      padding: 0 200px 0 20px;
    }
  }
 .super{
    font-size: 12px;
    background-color: #000;
    color: #ffc500;
    height: 19px;
    line-height: 19px;
    border-radius: 8px;
    margin-left: 5px;
    padding: 0 10px;
 }
.gender {
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  color: #fff;
  font-size: 12px;
  border-radius: 4px;
  display: inline-block;
  margin-top: 5px;
  margin-left: 15px;
}
.gender_b {
  background-color: #409eff;
}
.gender_g {
  background-color: #fd5c8c;
}
.gender_w {
  background-color: #e6a23c;
}
</style>
